import Image from "next/image"

import { Buttons } from "components/Button"
import Hero from "components/Hero"
import Layout, { Container, Section } from "components/Layout"
import SEO from "components/Seo"
import { Heading } from "components/Text"
import Usps from "components/Usps"
import sectionTwoImg from "public/commercial-cctv-2.webp"
import sectionOneImg from "public/commercial-cctv.webp"
import sectionFourImg from "public/commercial-cctv.webp"
import heroImg from "public/commercial-hero.webp"
import sectionThreeImg from "public/maintenance-packages.webp"

import type { NextPage } from "next"

const CommercialCCTV: NextPage = () => {
  return (
    <>
      <SEO
        titleTag="Commercial CCTV | CCTV Derbyshire | 3HCCTV &amp; Alarms"
        metaDescription="Our Commercial CCTV team specialise in CCTV installation for business customers across Derbyshire, Nottinghamshire &amp; South Yorkshire."
        pageTitle="Commercial CCTV"
      />
      <Layout>
        <Hero
          image={heroImg}
          imageClass="!object-center"
          imageAlt="Commercial CCTV Derbyshire"
          heading="Commercial CCTV"
          subHeading="Installation &amp; Repairs"
        />

        <Usps />

        <Section>
          <Container className="flex gap-6 smmax:flex-col-reverse flex-wrap mdmin:items-center">
            <div className="flex-1">
              <Heading>Commercial CCTV installation</Heading>
              <p>
                <strong>
                  A commercial CCTV installation from 3H CCTV will help to keep
                  your business safe and secure 24/7. We use state of the art
                  CCTV hardware and combine it with the latest CCTV software to
                  ensure that your commercial CCTV installation is efficient and
                  easy to use.
                </strong>
              </p>
              <p>
                Every business will have its own set of unique needs and
                requirements which is why we treat every job as being bespoke in
                nature. Speak to a member of the CCTV installation team at 3H
                CCTV and arrange an appointment to discuss your businesses
                security needs.
              </p>
              <Buttons buttons={[{ kind: "phone" }, { kind: "email" }]} />
            </div>
            <Image
              src={sectionOneImg}
              sizes="(max-width: 748px) 80vw, 40vw"
              alt="Commercial CCTV Derbyshire"
              placeholder="blur"
              className="mdmin:w-1/3 smmax:w-1/2 object-cover aspect-square"
            />
          </Container>
        </Section>

        <Section variant="gray-100">
          <Container className="flex gap-6 smmax:flex-col-reverse mdmin:flex-row-reverse flex-wrap mdmin:items-center">
            <div className="flex-1">
              <Heading>Commercial CCTV repairs</Heading>
              <p>
                We provide professional repairs for all types of commercial CCTV
                systems across the Midlands and South Yorkshire. Arrange for a
                skilled member of our commercial CCTV team to visit your place
                of work at a time suitable to you. Then our expert engineers
                will assess the damage and provide costings to either fix or
                replace the faulty equipment prior to any work being undertaken.
              </p>
              <Buttons buttons={[{ kind: "phone" }, { kind: "email" }]} />
            </div>
            <Image
              src={sectionTwoImg}
              sizes="(max-width: 748px) 80vw, 40vw"
              alt="Commercial CCTV repair Derbyshire"
              placeholder="blur"
              className="mdmin:w-1/3 smmax:w-1/2 object-cover aspect-square"
            />
          </Container>
        </Section>

        <Section>
          <Container className="flex gap-6 smmax:flex-col-reverse flex-wrap mdmin:items-center">
            <div className="flex-1">
              <Heading>Commercial CCTV maintenance packages</Heading>
              <p>
                We have a selection of maintenance packages tailored for our
                commercial customers. Keep your system up to date and ensure
                your place of business is always safe and secure.
              </p>
              <Buttons buttons={[{ kind: "phone" }, { kind: "email" }]} />
            </div>
            <Image
              src={sectionThreeImg}
              sizes="(max-width: 748px) 80vw, 40vw"
              alt="Commercial CCTV maintenance packages Derbyshire"
              placeholder="blur"
              className="mdmin:w-1/3 smmax:w-1/2 object-cover aspect-square"
            />
          </Container>
        </Section>

        <Section variant="gray-100">
          <Container className="flex gap-6 smmax:flex-col-reverse mdmin:flex-row-reverse flex-wrap mdmin:items-center">
            <div className="flex-1">
              <Heading>Commercial security emergencies</Heading>
              <p>
                We operate an emergency callout repair and replacement service.
                Our team of security technicians can attend your commercial
                premises to assist with your security emergency and quickly
                restore your security system to full working order.
              </p>
              <Buttons buttons={[{ kind: "phone" }, { kind: "email" }]} />
            </div>
            <Image
              src={sectionFourImg}
              sizes="(max-width: 748px) 80vw, 40vw"
              alt="Commercial security emergencies Derbyshire"
              placeholder="blur"
              className="mdmin:w-1/3 smmax:w-1/2 object-cover aspect-square"
            />
          </Container>
        </Section>
      </Layout>
    </>
  )
}

export default CommercialCCTV
